export default {
  data() {
    return {
      leftCurrentScrollTop: 0,
      rightCurrentScrollTop: 0,
      rightDetailScrollTop: 0
    };
  },
  methods: {
    // 设置左右两侧滚动条位置
    setScrollTop(curDom, position = 0) {
      setTimeout(() => {
        let dom = document.getElementById(curDom);
        if (dom) {
          dom.scrollTop = position;
        }
      }, 200);
    },
    // 监听左侧滚动
    listenLeftScroll() {
      let leftScroll = document.getElementById("leftScroll");
      this.leftCurrentScrollTop = leftScroll.scrollTop;
    },
    // 监听右侧滚动
    listenRightScroll() {
      // 右侧有两种状态，一种是wiki默认状态的滚动条位置，一种是看文章时的滚动条位置
      let rightScroll = document.getElementById("rightScroll");
      if (this.isShowDetailBox) {
        this.rightDetailScrollTop = rightScroll.scrollTop;
      } else {
        this.rightCurrentScrollTop = rightScroll.scrollTop;
      }
    }
  },
  activated() {
    const { leftCurrentScrollTop, rightCurrentScrollTop, rightDetailScrollTop } = this;
    if (leftCurrentScrollTop) {
      this.setScrollTop("leftScroll", leftCurrentScrollTop);
    }
    if (this.isShowDetailBox) {
      if (rightDetailScrollTop) {
        this.setScrollTop("rightScroll", rightDetailScrollTop);
      }
    } else if (rightCurrentScrollTop) {
      if (rightCurrentScrollTop) {
        this.setScrollTop("rightScroll", rightCurrentScrollTop);
      }
    }
  },
  mounted() {
    // 监听左右滚动
    const leftScroll = document.getElementById("leftScroll");
    const rightScroll = document.getElementById("rightScroll");
    leftScroll.addEventListener("scroll", this.listenLeftScroll);
    rightScroll.addEventListener("scroll", this.listenRightScroll);
  },
  beforeDestroy() {
    const leftScroll = document.getElementById("leftScroll");
    const rightScroll = document.getElementById("rightScroll");
    leftScroll && leftScroll.removeEventListener("scroll", this.listenLeftScroll);
    rightScroll && rightScroll.removeEventListener("scroll", this.listenRightScroll);
  }
};
